import styles from "../../styles/pages/herkunft/ortschaften.module.css"
import Collapsible from "../../components/collapsible/collapsible";
import Layout from "../../components/shared/layout/layout";
import Link from "next/link";
import Seo from "../../components/shared/seo/seo";


export default function Ortschaften() {
    return (
        <Layout>
            <Seo title="Ortschaften" description="Die Ortschaften rund um unser Weingut." path="/herkunft/ortschaften" />
            <section className={styles.heroHeader}>
                <Link href="/herkunft">
                    <p className="marker-back goBack annotation white"><b>Zurück</b></p>
                </Link>
                <h1 className="didot-bold uppercase size-85 white">Ortschaften</h1>
            </section>
            <section>
                <h2 className="white">Orte</h2>
                <div className="horizontal">
                <div className="col-6">
                    <img alt=""  src="/images/ortschaften_orte.webp" width="494" height="326"/>
                </div>
                <div className="col-6 broad left">
                    <p className="narrow white">Im Südosten der Thermenregion befindet sich ihre Burgunderinsel, das Steinfeld. Die Teile davon, in denen unsere Weingärten stehen, sind Teesdorf & Tattendorf.
                        Trotz der Nähe der Ortschaften zueinander, ergeben ihre Unterschiede in voneinander abweichenden kleinklimatischen Bedingungen und Bodenzusammensetzungen die Auswahl der Rebsorten.
                        <br/> <br/>
                        Die gekelterten Weine aus diesen Orten, sehen wir als Botschafter des Terroirs unserer Heimatgemeinden an, geprägt durch den herkunftsorientieren Geschmack und dem damit verbundenen Namen. </p>
                </div>
                </div>
                <div className="horizontal">
                    <div className="col-6"></div>
                    <div className="col-6 left broad">
                        <div className="horizontal left" style={{justifyContent:"start"}}>
                                <Link href="#teesdorf"><p className="white annotation marker link">Teesdorf</p></Link>
                                <Link href="#tattendorf"><p className="white annotation marker link">Tattendorf</p></Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="background_light ">
                <span  className="anchor" id="teesdorf" ></span>
                <div className={`col-12 ${styles.teesdorf}`}>
                    <h2 style={{marginBottom:0}}>Teesdorf</h2>
                    <p className="robertson brown subtitle size-40" style={{marginTop: "0"}}>Unsere&nbsp;&nbsp;Heimat</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 start">
                        <p>Als Familie sind wir seit jeher mit unserer Heimatgemeinde Teesdorf, wie unsere Rebstöcke verwurzelten.<br/><br/>

                            Wenn man in den Morgenstunden beim Sonnenaufgang Richtung Osten sieht, erblickt man, das Funkeln der Tautropfen auf den Weinblättern und das Leuchten der ersten Sonnenstrahlen, die über das Leithagebirge scheinen. Der pannonische Wind bläst über die Ebene durch Windränder und trifft auf die nach Süd und Ost geöffneten Weingartenfluren Teesdorfs.<br/><br/>

                            Gerade im Sommer erinnern die Abende, geprägt von der untergehenden orangeroten Sonne die Ebene an eine Savanne Afrikas. Im Süden erheben sich die Ausläufer der Alpen. Inmitten erstrahlt der weißschimmernde Schneeberg.
                        </p>
                    </div>
                    <div className="col-6 start">
                        <p>Nach alter Überlieferung kommt der Ursprung unseres Ortsnamens aus dem Keltischen. Die erste Silbe „tees“ bedeutet einen Platz, an dem Hirten Rinderzucht betreiben. Erstmals urkundlich erwähnt wurde der Ort in einem Brief an den Kellermeister des Stiftes Heiligenkreuz vom Teesdorfer Heim im Jahre 1365.  In dieser Zeit gab es bereits Weingärten in Teesdorf.<br/><br/>

                            Die kleinklimatischen Voraussetzungen und vor allem die Böden sind prädesdiniert für Weißburgunder, Pinot Gris und Chardonnay und in den kargsten Abschnitten für St.Laurent. Die Bodenschichten sind geprägt von Kalksteinablagerungen des einstigen Urmeeres, des Pannonsees und kaltzeitlichen Flussschottern. Die Salzigkeit und Mineralität unsere Weine sind darauf zurückzuführen, dass wir uns so zu sagen auf den Meeresgrund befinden. </p>
                    </div>
                </div>
                <div className="col-12">
                    <Link href="/weinkauf/shop"><p className="button secondary x2">Zu den Ortsweinen</p></Link>
                </div>
                <div className="col-12" style={{marginTop: "100px", marginBottom: "100px"}}>
                    <hr size="1" width="100%" style={{borderTop:"4px dotted #7C6765"}}/>
                </div>
                <span  className="anchor" id="tattendorf" ></span>
                <div className={`col-12 ${styles.tattendorf}`}>
                    <h2 style={{marginBottom: 0}}>Tattendorf</h2>
                    <p className="robertson subtitle brown size-40" style={{marginTop: 0}}>Unser Nachbar</p>
                </div>
                <div className="horizontal">
                    <div className="col-6 start">
                        <p>Wenn man den schönsten Überblick über die Weingärten Tattendorfs haben möchte muss auf die Aussichtsplattform. Inmitten der Weingärten eingebettet vom Windschutzgürteln erstrecken sich die Tattendorfer Rieden. Der Blick Richtung Westen über den Ort hinweg, erstreckt sich der der Wienerwald, wo man an den Hängen des Anningers Weingärten sichtet. Fallwinde vom Westen bringen über die Region meistens eine Abkühlung. Im Norden ist am Horizont unseren Hauptstadt zu erkennen.
                            Beim Verlassen der Plattform zahlt sich ein Rundgang über St.Laurentweg aus. Tattendorf wurde vermutlich in der Mitte des
                            11. Jahrhunderts von den Babenbergern gegründet und besiedelt.  </p>
                    </div>
                    <div className="col-6 start">
                        <p>Das Stift Klosterneuburg war ab der Mitte des 12. Jahrhunderts bis 1848 Grundherr. Ein früher Hinweis auf Weinbau findet sich 1258 mit dem pechrecht (Weingartenordnung).
                            <br/><br/>
                            Aufgrund der kargen Kalkschotterböden gedeihen hier auf rund 200 Hektar Anbaufläche (davon 80% Rotweinsorten) besonders gut die roten Burgundersorten (Pinot Noir & St. Laurent und Zweigelt. Das warme pannonische Klima sorgt für die Erwärmung der steinreichen Böden über den Tag und diese geben die Wärme über die Nachtstunden wieder langsam an die Rebstöcke ab, eine Grundlage für ein optimales Ausreifen der Trauben. </p>
                    </div>
                </div>
                <div className="col-12">
                    <Link href="/weinkauf/shop"><p className="button secondary x2 uppercase">Zu den Ortsweinen</p></Link>
                </div>
            </section>
        </Layout>
    );
}